jQuery(document).ready(function ($) {
  const form = $('.change-password-form');

  // Read PHP-provided values from data attributes on the form
  const loginUrl = form.data('login-url');

  // ---------------------------------------------------------------------------
  // Password visibility toggle
  // ---------------------------------------------------------------------------
  $('.password-toggle-btn').on('click', function () {
    const targetId = $(this).data('target');
    const $input = $('#' + targetId);
    const $eyeOff = $(this).find('.eye-off');
    const $eyeOn = $(this).find('.eye-on');

    if ($input.attr('type') === 'password') {
      $input.attr('type', 'text');
      $eyeOff.hide();
      $eyeOn.show();
    } else {
      $input.attr('type', 'password');
      $eyeOff.show();
      $eyeOn.hide();
    }
  });

  // ---------------------------------------------------------------------------
  // Change password form submit
  // ---------------------------------------------------------------------------
  form.on('submit', function (e) {
    e.preventDefault();
    $('#loading').addClass('d-flex');

    const currentPassword = $('#current-password').val();
    const newPassword = $('#new-password').val();
    const confirmPassword = $('#confirm-password').val();
    const nonce = $('#change_password_nonce').val(); // wp_nonce_field hidden input
    const $messageDiv = $('.password-message');
    const $submitBtn = $(this).find('button[type="submit"]');

    // Helper: show an error message
    function showError(msg) {
      $messageDiv
        .text(msg)
        .removeClass('success')
        .addClass('error')
        .css({
          'background-color': '#fbe9e7',
          color: '#5c5c5c',
          border: '1px solid #d84315',
        })
        .show();
      $('#loading').removeClass('d-flex');
    }

    // Clear previous messages
    $messageDiv.hide().removeClass('success error');

    if (typeof qcs_account_security === 'undefined') {
      console.info('Localized data is missing.');
      return;
    }

    showError(qcs_account_security.msg_mismatch);

    // Client-side validation — strings come from the localized object
    if (newPassword !== confirmPassword) {
      showError(qcs_account_security.msg_mismatch);
      return;
    }

    if (newPassword.length < 8) {
      showError(qcs_account_security.msg_too_short);
      return;
    }

    $submitBtn.prop('disabled', true).text(qcs_account_security.msg_updating);
    
    if (typeof ajax_callback_data === 'undefined') {
      console.info('ajax_callback_data is not defined.');
      return;
    }

    $.ajax({
      url: ajax_callback_data.ajax_url, // injected globally by wp_localize_script
      type: 'POST',
      data: {
        action: 'change_user_password',
        current_password: currentPassword,
        new_password: newPassword,
        nonce: nonce,
      },
      success: function (response) {
        if (response.success) {
          window.location.href = loginUrl;
        } else {
          showError(
            response.data.message || qcs_account_security.msg_error_generic,
          );
          $('#loading').removeClass('d-flex');
        }
      },
      error: function () {
        showError(qcs_account_security.msg_error_ajax);
        $('#loading').removeClass('d-flex');
      },
      complete: function () {
        $submitBtn
          .prop('disabled', false)
          .text(qcs_account_security.msg_confirm);
      },
    });
  });
});

// ---------------------------------------------------------------------------
// Material input — floating label "has-value" state
// ---------------------------------------------------------------------------
document.addEventListener('DOMContentLoaded', function () {
  initializeMaterialInputs();
});

function initializeMaterialInputs() {
  const inputs = document.querySelectorAll(
    '.material-input input, .material-input textarea',
  );

  inputs.forEach(function (input) {
    checkInputValue(input);
    input.addEventListener('input', function () {
      checkInputValue(this);
    });
    input.addEventListener('blur', function () {
      checkInputValue(this);
    });
  });
}

function checkInputValue(input) {
  input.classList.toggle('has-value', input.value.trim() !== '');
}
